import api from '../utils/request';

export const EventType = {
  INTERVIEW: "INTERVIEW",
  MEETING: "MEETING",
  OTHER: "OTHER"
};

const isValidEventType = (eventType) => {
  const validTypes = Object.values(EventType);
  return validTypes.includes(eventType);
};

const calendarEventApi = {
  getAllEvents: async () => {
    const response = await api.get('/calendar_event/');
    return response.data;
  },

  getEventDetails: async (eventId) => {
    const response = await api.get(`/calendar_event/${eventId}`);
    return response.data;
  },

  createEvent: async (eventData) => {
    if (eventData.event_type && !isValidEventType(eventData.event_type)) {
      throw new Error(`无效的事件类型: ${eventData.event_type}。只支持: ${Object.values(EventType).join(', ')}`);
    }

    const formattedData = {
      title: eventData.title,
      event_type: eventData.event_type,
      date: eventData.date,
      time: eventData.time,
      location: eventData.location || '',
      extra_data: eventData.extra_data || null
    };
    const response = await api.post('/calendar_event/', formattedData);
    return response.data;
  },

  updateEvent: async (eventId, eventData) => {
    if (eventData.event_type !== undefined && !isValidEventType(eventData.event_type)) {
      throw new Error(`无效的事件类型: ${eventData.event_type}。只支持: ${Object.values(EventType).join(', ')}`);
    }

    const response = await api.patch(`/calendar_event/${eventId}`, eventData);
    return response.data;
  },

  deleteEvent: async (eventId) => {
    const response = await api.delete(`/calendar_event/${eventId}`);
    return response.data;
  },

  updateEventStatus: async (eventId, isCompleted) => {
    const response = await api.patch(`/calendar_event/${eventId}/status`, { is_completed: isCompleted });
    return response.data;
  }
};

export default calendarEventApi;
